<template>
    <div>
        <section class="material-half-bg">
            <div class="cover"></div>
        </section>
        <section class="login-content">
            <div class="logo">
                <img src="../assets/logo.png" alt="Cocall"/>
            </div>
            <div class="login-box">
                <form @submit="reset" class="login-form">
                    <h3 class="login-head"><i class="fa fa-lg fa-fw fa-key"></i>{{$t('resetPassword')}}</h3>
                    <form-input :label="$t('newPassword')" type="password" attribute="password" :model="form" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
                    <form-input :label="$t('rePassword')" type="password" attribute="rePassword" :model="form" :errors="errors" :placeholder="$t('passwordPlaceholder')"></form-input>
                    <div class="form-group btn-container">
                        <button @click="reset" class="btn btn-primary btn-block">
                            {{$t('reset')}}
                        </button>
                    </div>
                    <p class="semibold-text mt-3"><router-link to="/login">{{$t('loginPage')}}</router-link></p>
                </form>
            </div>
            <lang></lang>
        </section>
    </div>
</template>

<script>
    import Lang from "../components/Lang";

    export default {
        components: {Lang},
        props: ['token'],
        data: function () {
            return {
                form: {},
                errors: {}
            };
        },
        i18n: {
            messages: {
                en: {
                    newPassword: 'New password',
                    rePassword: 'Confirm password',
                    passwordPlaceholder: 'Password',
                    resetPassword: "Password recovery",
                    reset: "Reset password",
                    loginPage: "Back to login page",
                    successTxt: "Your password has been reset successfully, you can login with new password!",
                    failed: "Password recovery request has expired or invalidated, you can resend forgot password request!"
                },
                vi: {
                    newPassword: 'Mật khẩu mới',
                    rePassword: 'Xác nhận mật khẩu',
                    passwordPlaceholder: 'Mật khẩu',
                    resetPassword: "Khôi phục mật khẩu",
                    reset: "Đặt lại mật khẩu",
                    loginPage: "Quay lại trang đăng nhập",
                    successTxt: "Đặt lại mật khẩu thành công, bây giờ bạn có thể đăng nhập bằng mật khẩu mới!",
                    failed: "Yêu cầu khôi phục mật khẩu đã hết hạn hoặc không hợp lệ, bạn có thể gửi lại yêu cầu quên mật khẩu!"
                }
            }
        },

        methods: {
            reset: function (evt) {
                evt.preventDefault();
                let loader = this.$loading.show();
                this.form.token = this.token;
                this.errors = {};
                this.$service.post('/auth/reset', this.form).then(response => {
                    if (response.data) {
                        this.$swal({
                            title: this.$t('success'),
                            text: this.$t('successTxt'),
                            icon: 'success'
                        }).then(() => {
                            this.$router.push('/login');
                        });
                    } else {
                        this.$swal({
                            title: this.$t('error'),
                            text: this.$t('failed'),
                            icon: 'error'
                        }).then(() => {
                            this.$router.push('/forgot');
                        });
                    }
                }).catch(error => {
                    this.errors = error.response.data;
                }).finally(() => {
                    loader.hide();
                });
            }
        }
    };
</script>